module.exports = __webpack_public_path__ + "img/BAAC.870ad76e.png";